import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import AddToCampaignModal from './../InfluencerList/AddToCampaignModal';

// material-ui
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Typography from '@mui/material/Typography';
import Select from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import { showPremiumFeatureDialog, fetchInfluencersAction, updatePage } from 'actions/planner2';
import MainCard from 'ui-component/cards/MainCard';
import AiUserList from './AiUserList';
import mixpanel from '../../../../utils/mixpanel';
// project imports
// import UserList from './UserList';
import { gridSpacing } from 'store/constant';

const scrollToTop = async () => {
  window.scrollTo({
    top: 0,
    behavior: 'auto', // This enables smooth scrolling
  });
};

// ==============================|| USER LIST STYLE 1 ||============================== //

const AiInfluencerList = ({
  influencers,
  totalResults,
  loading,
  isAuth,
  onPlatformChange,
  noInfluencers,
  listName,
  onPageChange,
  onSortChange,
  onSearch,
  isDiscover,
  planPlatform,
  useCategorySort,
  planUUID,
  errorMassage,
  downloadReport,
  successMassage,
  successCount,
  filters,
  detectedLocation,
  // updateFilters,
}) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.planner2.user);
  const page = useSelector((state) => state.planner2.page);
  const [aiSortBy, setAiSortBy] = React.useState('relevancy');
  const [openAddToCampaign, setOpenAddToCampaign] = React.useState(false);
  const [openModalCondition, setOpenModalCondition] = useState('');
  const [addToCampaignInfluencers, setAddToCampaignInfluencers] = React.useState([]);
  // const [localPayload, setLocalPayload] = React.useState({...payload})

    const conditionalDispatch = (action) => {
      if (isAuth !== 'noAuth') {
        dispatch(action);
      }
    };

    const updatePageWithoutDispatch = (updatedPage) => {
      onPageChange(updatedPage);
    };

    const handleAiSortByChange = (event) => {
      const newSortBy = event.target.value;
      setAiSortBy(newSortBy);
      onSortChange(newSortBy);
      if (isAuth === 'planner' || isAuth === 'noAuth') {
      }
    };

  //   const handleSortByChange = (event) => {
  //     const newSortBy = event.target.value;
  //     setSortBy(newSortBy);
  //     if (isAuth === 'planner' || isAuth === 'noAuth') {
  //       onSortChange(newSortBy);
  //     }
  //   };

  //   useEffect(() => {
  //     conditionalDispatch(updateFilters('sortBy', sortBy, true, true));
  //   }, [sortBy]);

  //   const handleDownload = () => {
  //     getPlannerDownload({
  //       selected_ids: Array.from(selectedInfluencers),
  //       objective: '',
  //       prediction: {},
  //       contacts: 'not_req',
  //       selectedColumns: [],
  //     });
  //   };

    const handleAddToCampaign = (influencerIds, isAuth) => {
      setOpenModalCondition(isAuth);
      const infs = influencers.filter((inf) => influencerIds.includes(inf.id));
      setAddToCampaignInfluencers(infs);
      setOpenAddToCampaign(true);
    };

  //   const handlePlatformChange = (event) => {
  //     const newPlatform = event.target.value;
  //     setPlatform(newPlatform);
  //     onPlatformChange(newPlatform);
  //   };

  //   const handleDiscoverClick = () => {
  //     if (process.env.NODE_ENV === 'production') {
  //       mixpanel.track('collab_list_add_influencer');
  //     }
  //     history.push('/planner/discover');
  //   };
  //   const handleShareClick = () => {
  //     // Copy the current page URL to the clipboard
  //     // navigator.clipboard.writeText(window.location.href);
  //     setButtonVariant('contained');
  //     setShareDialogOpen(true);
  //     navigator.clipboard.writeText(window.location.href);
  //     // setTimeout(() => setButtonVariant('outlined'), 2000);
  //   };

  //   function SlideTransition(props) {
  //     return <Slide {...props} direction="right" />;
  //   }

  //   const handleClose = (event, reason) => {
  //     if (reason === 'clickaway') {
  //       return;
  //     }
  //     setShareDialogOpen(false);
  //   };

  //   const handleCLoseBulkStatus = (event, reason) => {
  //     if (reason === 'clickaway') {
  //       return;
  //     }
  //     setBulkUploadingStatus(false);
  //   };

  //   function handleAddInfluencers() {
  //     if (isAuth === 'noAuth') {
  //       history.push('/signup');
  //     } else {
  //       setOpenAddInfluencerModal(true);
  //     }
  //   }
  //   // function handleAddInfluencersClose() {
  //   //   setAddInfluencerModal(false);
  //   // }

  //   useEffect(() => {
  //     if (isDiscover) {
  //       if (
  //         isSortApplied === false &&
  //         (Object.keys(filters).length > 6 ||
  //           filters.bio ||
  //           filters.category ||
  //           filters.ids ||
  //           filters.posts)
  //       ) {
  //         setSortBy('followers');
  //         setIsSortApplied(true);
  //       }else if(filters.platform === 'youtube' ){
  //         setIsSortApplied(true)
  //       } else if (
  //         isSortApplied === true &&
  //         filters.sortBy === 'category' &&
  //         Object.keys(filters).length === 6 &&
  //         filters.platform === 'instagram' &&
  //         filters.bio  === null &&
  //           filters.category === null &&
  //           filters.ids === null &&
  //           filters.posts === null
  //       ) {
  //         setSortBy('category');
  //         setIsSortApplied(false);
  //       }
  //     }
  //   }, [filters]);
  //   useEffect(() => {
  //     if (isAuth === 'planner') {
  //       if (!isDiscover) {
  //         try {
  //           const uploadingStatus = setInterval(() => {
  //             colabImportStatus(planUUID).then((resp) => {
  //               setUploadStatus(resp);
  //               // console.log('response', resp);
  //               if (resp.status === 'processing') {
  //                 setBulkUploadingStatus(true);
  //                 setStatusData((data) => ({
  //                   ...data,
  //                   total_count: resp.total_count,
  //                   success_count: resp.success_count,
  //                   failed_count: resp.failed_count,
  //                 }));
  //               }
  //               if (
  //                 resp.status === 'completed' ||
  //                 resp.status === 'Draft' ||
  //                 resp.success_count + resp.failed_count === resp.total_count
  //               ) {
  //                 // setBulkUploadingStatus(false);
  //                 colabImportStatus(planUUID).then(async (resp) => {
  //                   await setUploadStatus(resp);
  //                   if (resp.status === 'completed') {
  //                     setStatusData((data) => ({
  //                       ...data,
  //                       total_count: resp.total_count,
  //                       success_count: resp.success_count,
  //                       failed_count: resp.failed_count,
  //                     }));
  //                   }
  //                 });
  //                 clearInterval(uploadingStatus);
  //               }
  //             });
  //           }, 500);
  //         } catch (e) {
  //           console.log('error', e);
  //           throw e;
  //         }
  //       }
  //     }
  //   }, []);

  //   useEffect(() => {
  //     if (statusData.failed_count > 0) {
  //       errorMassage(true);
  //     }
  //     if (
  //       bulkUploadingStatus &&
  //       statusData.total_count > 0 &&
  //       statusData.success_count === statusData.total_count
  //     ) {
  //       successMassage(true);
  //     }
  //     if (statusData.success_count + statusData.failed_count < statusData.total_count) {
  //       setOpenAddInfluencerModal(false);
  //     }
  //     if (!isDiscover) {
  //       successCount(statusData.success_count);
  //     }
  //   }, [statusData.failed_count, statusData.success_count, statusData.total_count]);
  return (
    <MainCard
      sx={{
        '& .MuiCardHeader-root': {
          height: 70,
        },
      }}
      title={
        <Grid container alignItems="center" justifyContent="space-between" spacing={gridSpacing}>
          {/* {openAddInfluencerModal ? (
            <AddInfluencerModal
              open={openAddInfluencerModal}
              close={(val) => setOpenAddInfluencerModal(val)}
              planPlatform={planPlatform}
              planUUID={planUUID}
              bulkUploadingStatus={(val) => setBulkUploadingStatus(val)}
              errorMassage={(val) => errorMassage(val)}
              downloadReport={downloadReport}
              statusData={(val) =>
                setStatusData((data) => ({
                  ...data,
                  total_count: val.total_count,
                  success_count: val.success_count,
                  failed_count: val.failed_count,
                }))
              }
            >
              {' '}
            </AddInfluencerModal>
          ) : (
            ''
          )} */}
          <Grid item md={12}>
            <Grid container alignItems={'center'} justifyContent='start' direction="column" spacing={0.5}>
              <Grid item container alignItems={'center'} justifyContent='space-between' width="100%">
                <Grid item md={4}>
                  <Typography variant="h3">
                    {isAuth === 'planner' || isAuth === 'noAuth'
                      ? listName
                      : `AI RECOMMENDED INFLUENCERS`}{' '}
                    {!loading && (totalResults == null || totalResults === 0)
                      ? ''
                      : `(${parseInt(totalResults).toLocaleString('en-IN')})`}
                  </Typography>
                </Grid>
                <Grid item md={8} textAlign={'end'}>
                  <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                    <InputLabel id="age-select">Sort by</InputLabel>
                    <Select
                      labelId="platform-select"
                      id="sortBy"
                      name="sortBy"
                      value={aiSortBy}
                      onChange={handleAiSortByChange}
                      label="Sort By"
                    >
                      <MenuItem value={'relevancy'}>Relevancy</MenuItem>
                      <MenuItem value={'followers'}>Followers</MenuItem>
                      <MenuItem value={'avg_views'}>Avg Views</MenuItem>
                      <MenuItem value={'engagement_rate'}>Eng Rate</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          {/* <Grid item>
            <Grid container alignItems="center" spacing={0}>
              {!isDiscover ? (
                <Grid item>
                  <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
                    <OutlinedInput
                      placeholder="Search by influencer name"
                      onChange={(event) => {
                        onSearch(event.target.value);
                        // setSearchInfluencer(event.target.value);
                      }}
                      startAdornment={
                        <InputAdornment position="start">
                          <SearchIcon></SearchIcon>
                        </InputAdornment>
                      }
                    ></OutlinedInput>
                  </FormControl>
                </Grid>
              ) : (
                ''
              )}
              {isAuth === 'planner' || isAuth === 'noAuth' ? (
                <Grid item>
                  <FormControl sx={{ m: 1, minWidth: 180 }} size="small">
                    <InputLabel id="platform-select">Platform</InputLabel>
                    <Select
                      labelId="platform-select"
                      id="platform"
                      name="platform"
                      value={platform}
                      onChange={(event) => handlePlatformChange(event)}
                      label="Platform"
                    >
                      <MenuItem value={'all'}>All Platforms</MenuItem>
                      <MenuItem value={'instagram'}>Instagram</MenuItem>
                      <MenuItem value={'youtube'}>YouTube</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              ) : (
                ''
              )}

              <Grid item>
                <FormControl sx={{ m: 1, minWidth: 120 }} size="small">
                  <InputLabel id="age-select">Sort by</InputLabel>
                  <Select
                    labelId="platform-select"
                    id="sortBy"
                    name="sortBy"
                    value={sortBy}
                    onChange={handleSortByChange}
                    label="Sort By"
                  >
                    {useCategorySort && <MenuItem value={'category'}>Category</MenuItem>}
                    <MenuItem value={'followers'}>Followers</MenuItem>
                    <MenuItem value={'views'}>Avg Views</MenuItem>
                    <MenuItem value={'eng-rate'}>ER</MenuItem>
                  </Select>
                </FormControl>
              </Grid>

              {isAuth === 'planner' || (isAuth === 'noAuth' && !noInfluencers) ? (
                <Grid item>
                  <FormControl sx={{ m: 1, minWidth: 170 }} size="small">
                    <InputLabel id="age-select">More</InputLabel>
                    <Select
                      labelId="platform-select"
                      id="Action"
                      name="Action"
                      value={'Action'}
                      // onChange={handleSortByChange}
                      label="Action"
                    >
                      <MenuItem sx={{ display: 'none' }} value={'Action'}>
                        More Actions
                      </MenuItem>
                      <MenuItem onClick={handleShareClick}>
                        <ShareIcon sx={{ height: 18, mr: '10px' }}></ShareIcon> Share List
                      </MenuItem>
                      <MenuItem onClick={handleAddInfluencers}>
                        <AddIcon sx={{ height: 20, mr: '10px' }}></AddIcon> Add Influencers
                      </MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
              ) : null}
            </Grid>
          </Grid> */}
        </Grid>
      }
      content={false}
    >
      {/* {noInfluencers ? (
        <>
          <img src={empty} style={{ width: '300px' }}></img>
          <Typography variant="h6" color="textSecondary" sx={{ textAlign: 'center', marginTop: 4 }}>
            No influencers have been added to this list !
          </Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => setOpenAddInfluencerModal(true)}
          >
            Add Influencers
          </Button>
        </>
      ) : (
        // Otherwise show the respective list based on the isAuth prop
        <>
          {isAuth === 'planner' || isAuth === 'noAuth' ? (
            <PlannerUserList
              influencers={influencers}
              loading={loading}
              handleAddToCampaign={handleAddToCampaign}
              platform={platform}
              openShareDialog={shareDialogOpen}
              setShareDialogOpen={setShareDialogOpen}
              listName={listName}
              isAuth={isAuth}
            />
          ) : (
            <UserList
              influencers={influencers}
              loading={loading}
              handleAddToCampaign={handleAddToCampaign}
            />
          )}
        </>
      )} */}
      {!loading && (!influencers || influencers.length === 0) ? (
        <Box
          sx={{
            py: 8,
            px: 2,
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '12px',
            background: 'linear-gradient(-45deg, rgba(33, 150, 243, 0.05), rgba(156, 39, 176, 0.05), rgba(255, 87, 34, 0.05), rgba(76, 175, 80, 0.05))',
            backgroundSize: '400% 400%',
            animation: 'gradientAnimation 10s ease infinite',
            '@keyframes gradientAnimation': {
              '0%': { backgroundPosition: '0% 50%' },
              '50%': { backgroundPosition: '100% 50%' },
              '100%': { backgroundPosition: '0% 50%' }
            },
            border: '1px solid rgba(255, 255, 255, 0.1)',
            backdropFilter: 'blur(5px)',
            minHeight: '200px',
            mx: 2,
            mt: 2
          }}
        >
          <Typography
            variant="h4"
            sx={{
              fontWeight: 500,
              background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              mb: 1
            }}
          >
            Enter details in the search box above to find AI recommended influencers
          </Typography>
        </Box>
      ) : (
        <AiUserList
          influencers={influencers}
          loading={loading}
          handleAddToCampaign={handleAddToCampaign}
          detectedLocation={detectedLocation}
        />
      )}

      {/* {text === 'planner'?
            <PlannerUserList 
                influencers={influencers} 
                loading={loading} 
                handleAddToCampaign={handleAddToCampaign}
                platform={platform} 
            />:
            <UserList influencers={influencers} loading={loading} handleAddToCampaign={handleAddToCampaign} />} */}
      <Grid item xs={12} sx={{ p: 3 }}>
        <Grid container justifyContent="space-between" spacing={gridSpacing}>
          <Grid item>
            <Pagination
              count={Math.ceil(totalResults / 20)}
              color="primary"
              page={page}
              onChange={(e, updatedPage) => {
                if (user.premium_user || updatedPage < 4) {
                  updatePageWithoutDispatch(updatedPage);
                  if (isAuth === 'planner' || isAuth === 'noAuth') {
                  }
                  conditionalDispatch(updatePage(updatedPage));
                  conditionalDispatch(fetchInfluencersAction(updatedPage));
                  scrollToTop();
                  if (process.env.NODE_ENV === 'production') {
                    if (isDiscover) {
                      mixpanel.track(`Discover - Page clicked`, {
                        page: updatedPage,
                      });
                    } else {
                      mixpanel.track(`Page clicked`, {
                        page: updatedPage,
                      });
                    }
                  }
                } else conditionalDispatch(showPremiumFeatureDialog(true));
              }}
            />
          </Grid>
        </Grid>
      </Grid>
      {isAuth !== 'noAuth' && (
        <AddToCampaignModal
          open={openAddToCampaign}
          setOpen={setOpenAddToCampaign}
          influencers={addToCampaignInfluencers}
          text={openModalCondition}
        />
      )}
    </MainCard>
  );
};

export default AiInfluencerList;
